var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 800",
    style: {
      enableBackground: "new 0 0 1000 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n\t.st9{fill:url(#SVGID_10_);}\n\t.st10{fill:url(#SVGID_11_);}\n\t.st11{fill:url(#SVGID_12_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.6292,
    y1: 150.1228,
    x2: 289.4555,
    y2: 553.8729
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1111,
    style: {
      stopColor: "#39B54A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5635,
    style: {
      stopColor: "#1F9242"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6831,
    style: {
      stopColor: "#1C8E41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8031,
    style: {
      stopColor: "#13823E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8968,
    style: {
      stopColor: "#08733B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005227"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M328.5,307.3l55.4-56.8v-34.6H209.6v40.3h114.1l-26.3,28l-37,39.4l14.5,15c4.8-1.1,9.8-1.7,15-1.7 c36.4,0,65.9,29.5,65.9,65.9s-29.5,65.9-65.9,65.9c-34.6,0-62.9-26.7-65.7-60.5h-37.2c2.8,54.4,47.8,97.7,102.9,97.7 c56.9,0,103.1-46.1,103.1-103.1C392.9,359.6,366.3,322.7,328.5,307.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 459.526,
    y1: 150.6138,
    x2: 458.3523,
    y2: 554.3638
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1111,
    style: {
      stopColor: "#39B54A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5635,
    style: {
      stopColor: "#1F9242"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6831,
    style: {
      stopColor: "#1C8E41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8031,
    style: {
      stopColor: "#13823E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8968,
    style: {
      stopColor: "#08733B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005227"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M461.1,295.2l68.3-79.9h-54.1L383,328.4c-2.7,3-5.3,6.1-7.7,9.4l-0.2,0.3l0,0c-12.1,16.9-19.3,37.6-19.3,60 c0,56.9,46.1,103.1,103.1,103.1s103.1-46.1,103.1-103.1C561.9,342,516.9,296.4,461.1,295.2z M458.8,464.1 c-36.4,0-65.9-29.5-65.9-65.9c0-13,3.8-25.1,10.3-35.3l0,0l12.2-14.2c11.6-10.2,26.8-16.4,43.5-16.4c36.4,0,65.9,29.5,65.9,65.9 S495.2,464.1,458.8,464.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.0583,
    y1: 528.0078,
    x2: 334.9385,
    y2: 612.5136
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#58595B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06802606,
    style: {
      stopColor: "#68696B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4471,
    style: {
      stopColor: "#BCBEC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5504,
    style: {
      stopColor: "#ABADAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8494,
    style: {
      stopColor: "#7E7F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D6E71"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M364.3,590.6v20.7h-59v-84.2h25.8v63.5H364.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.3523,
    y1: 527.4839,
    x2: 385.2326,
    y2: 611.9897
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#58595B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06802606,
    style: {
      stopColor: "#68696B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4471,
    style: {
      stopColor: "#BCBEC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5504,
    style: {
      stopColor: "#ABADAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8494,
    style: {
      stopColor: "#7E7F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D6E71"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M397.1,524.5V544h-24.6v-19.5H397.1z M397.1,548.6v62.7h-24.6v-62.7H397.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.9823,
    y1: 526.9044,
    x2: 440.8626,
    y2: 611.4102
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#58595B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06802606,
    style: {
      stopColor: "#68696B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4471,
    style: {
      stopColor: "#BCBEC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5504,
    style: {
      stopColor: "#ABADAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8494,
    style: {
      stopColor: "#7E7F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D6E71"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M471.3,611.3h-24.6v-39.5c0-3.2-0.5-5.3-1.5-6.2c-1-0.9-2.3-1.4-3.8-1.4c-4.5,0-6.7,3.1-6.7,9.4v37.7H410 v-62.7h22.8v8.9c3.4-6.8,9.4-10.2,18.1-10.2c4.6,0,8.4,0.9,11.6,2.6c3.1,1.7,5.4,4,6.8,6.8s2,7.6,2,14.5V611.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 516.8218,
    y1: 526.1039,
    x2: 517.702,
    y2: 610.6098
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#58595B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06802606,
    style: {
      stopColor: "#68696B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4471,
    style: {
      stopColor: "#BCBEC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5504,
    style: {
      stopColor: "#ABADAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8494,
    style: {
      stopColor: "#7E7F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D6E71"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M549,548.6l-19,21.5l21.1,41.2h-25.4L514,586.2l-6.7,7.8v17.3h-23.1v-84.2h23.1v34c0,0.9-0.1,4.7-0.2,11.3 c1.5-2.1,3-4,4.5-5.7l15.7-18.1H549z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 584.8782,
    y1: 525.3951,
    x2: 585.7584,
    y2: 609.9009
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#58595B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06802606,
    style: {
      stopColor: "#68696B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4471,
    style: {
      stopColor: "#BCBEC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5504,
    style: {
      stopColor: "#ABADAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8494,
    style: {
      stopColor: "#7E7F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D6E71"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M596.3,588.8l22.9,1.5c-1.4,6.2-4.8,11.4-10.4,15.8c-5.6,4.3-13.1,6.5-22.6,6.5c-10.6,0-19-3.1-25.3-9.2 c-6.3-6.1-9.4-13.7-9.4-22.7c0-9.4,3.1-17.3,9.3-23.7c6.2-6.5,14.5-9.7,24.9-9.7c10,0,18.1,3,24.3,9.1c6.2,6.1,9.3,14.4,9.3,24.9 c0,0.9,0,2.1-0.1,3.6h-42c0.1,3.9,0.8,6.9,2.1,8.8c1.3,1.9,3.8,2.9,7.5,2.9C592.3,596.5,595.4,593.9,596.3,588.8z M594.7,572.5 c0-4.2-0.9-7.1-2.6-8.5c-1.7-1.5-3.7-2.2-6.2-2.2c-5.8,0-8.7,3.6-8.7,10.7H594.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 657.7449,
    y1: 524.636,
    x2: 658.6252,
    y2: 609.1418
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#58595B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06802606,
    style: {
      stopColor: "#68696B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4471,
    style: {
      stopColor: "#BCBEC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5504,
    style: {
      stopColor: "#ABADAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8494,
    style: {
      stopColor: "#7E7F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D6E71"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M690.2,611.3h-23.1V603c-3.4,6.4-9,9.6-16.9,9.6c-7.2,0-13.1-2.8-17.6-8.5c-4.5-5.7-6.8-13.9-6.8-24.6 c0-10.1,2.3-18.1,6.8-24c4.5-5.9,10.5-8.9,17.9-8.9c6.2,0,11.3,2.4,15.4,7.1v-26.6h24.2V611.3z M666,571c0-5.6-2.3-8.4-7-8.4 c-3.2,0-5.4,1.8-6.4,5.4c-1,3.6-1.5,8-1.5,13.1c0,10.2,2.6,15.2,7.8,15.2c2,0,3.6-0.8,5-2.4c1.4-1.6,2.1-4,2.1-7.3V571z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 605.8824,
    y1: 195.4117,
    x2: 832.9919,
    y2: 419
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#58595B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06802606,
    style: {
      stopColor: "#68696B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4471,
    style: {
      stopColor: "#BCBEC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5504,
    style: {
      stopColor: "#ABADAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8494,
    style: {
      stopColor: "#7E7F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D6E71"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M667.7,215.4c-38.1,0-72.7,14.9-98.4,39.2l26.6,26.6c18.8-17.5,44.1-28.3,71.8-28.3c9.5,0,18.8,1.3,27.5,3.7 c6.5-6.6,15.5-10.7,25.4-10.7c19.7,0,35.6,16,35.6,35.6c0,5.3-1.2,10.4-3.3,14.9c12.6,17.4,20.1,38.8,20.1,61.9 c0,27.8-10.7,53-28.3,71.8l26.6,26.6c24.3-25.6,39.2-60.3,39.2-98.4C810.6,279.4,746.6,215.4,667.7,215.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 619.2779,
    y1: 181.8053,
    x2: 846.3873,
    y2: 405.3936
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#58595B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06802606,
    style: {
      stopColor: "#68696B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4471,
    style: {
      stopColor: "#BCBEC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5504,
    style: {
      stopColor: "#ABADAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8494,
    style: {
      stopColor: "#7E7F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6D6E71"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 720.6,
    cy: 281.6,
    r: 25.2
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 642.8297,
    y1: 151.1466,
    x2: 641.6559,
    y2: 554.8967
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1111,
    style: {
      stopColor: "#39B54A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5635,
    style: {
      stopColor: "#1F9242"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6831,
    style: {
      stopColor: "#1C8E41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8031,
    style: {
      stopColor: "#13823E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8968,
    style: {
      stopColor: "#08733B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005227"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M732.7,441.2c-17.9,14.1-40.5,22.5-65.1,22.5c-11.5,0-22.6-1.9-33-5.3c-5.4,3.3-11.8,5.3-18.6,5.3 c-19.7,0-35.6-16-35.6-35.6c0-3.1,0.4-6.1,1.2-9c-12.1-17.2-19.3-38.1-19.3-60.7c0-24.6,8.4-47.1,22.5-65.1l-26.7-26.7 c-20.8,24.8-33.3,56.8-33.3,91.7c0,78.9,64,142.9,142.9,142.9c34.9,0,66.9-12.5,91.7-33.3L732.7,441.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 616.7725,
    y1: 151.0709,
    x2: 615.5989,
    y2: 554.8209
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1111,
    style: {
      stopColor: "#39B54A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5635,
    style: {
      stopColor: "#1F9242"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6831,
    style: {
      stopColor: "#1C8E41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8031,
    style: {
      stopColor: "#13823E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8968,
    style: {
      stopColor: "#08733B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005227"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 616,
    cy: 428.1,
    r: 25.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedLogo);
export default __webpack_public_path__ + "static/media/linkedLogo.68332cfe1d2b79ee6689f8a809beca0f.svg";
export { ForwardRef as ReactComponent };